// @ts-nocheck
import {Clickable} from '/ui/components/clickable/clickable';
import {EntityModel, EntityTypeModel} from '/ui/components/entitypicker/datasource/datamodel';
import {getEntityIcon} from '/ui/components/entitypicker/entitylist/entityicon';
import * as styles from '/ui/components/entitypicker/entitylist/itemlist.module.scss';

/**
 * @param {{
 *   entity: !EntityModel,
 *   entityType: (!EntityTypeModel | number),
 *   onClick: function(): ?,
 *   role: (string | undefined),
 * }} props
 * @returns {React.ReactElement}
 */
export function EntityItem({
  entity,
  entityType,
  onClick,
  role = 'listitem',
}) {
  return (
    <Clickable
      tag="li"
      tid="uep-entity-item"
      onClick={onClick}
      className={`${styles.item} ${styles.entityItem}`}
      role={role}>
      <div className={styles.icon}>
        {getEntityIcon(entityType)}
      </div>
      <div className={styles.entityLabels}>
        <div className={styles.label}>{entity.label}</div>
        <div className={styles.sublabel}>{entity.sublabel}</div>
      </div>
    </Clickable>
  );
}
